import { combineReducers } from "redux";
import deptData from "../../system_mgt/reducer/sys_mgt_dept.reducer";
import packageData from "../../system_mgt/reducer/sys_mgt_business_package.reducer";
import menuData from "../../system_mgt/reducer/sys_mgt_menu.reducer";
import userData from "../../system_mgt/reducer/sys_mgt_user.reducer"
import workConditionData from "./run_monitor_work_condition.reducer";
import realTimeData from "../../common/reducer/run_monitor_real_time.reducer";
import compareAnalyzeData from "../../common/reducer/run_monitor_compare_analyze.reducer";
import roleData from "../../system_mgt/reducer/sys_mgt_role.reducer";
import alertSearchData from "../../common/reducer/run_monitor_alert_search.reducer";
import overViewData from "./ops_overview.reducer";

/**
 * 配电代运维Reducer
 */
const agencyMaintainReducer = combineReducers({
    deptData,  // 部门数据
    packageData, // 业务包数据
    menuData, // 菜单数据
    userData, // 用户数据
    roleData, // 角色数据
    workConditionData, // 工况查询数据
    realTimeData, // 实时监控数据
    compareAnalyzeData, // 对比分析数据
    alertSearchData, // 告警查询数据
    overViewData, // 用电单位概览信息
})

export default agencyMaintainReducer;
